import ServiceLandingPage from "../../ServiceLandingPage/ServiceLandingPage";

const graduateJobSearchService = {
  contentKey: "servicePages.graduateJobSearch",
  image: "/service-graduate-job-search.png",
  heroPosition: "center 32%",
  heroContentSx: {
    pt: { xs: 3, md: 8 },
  },
};

const GraduateJobSearchPage = () => {
  return <ServiceLandingPage service={graduateJobSearchService} />;
};

export default GraduateJobSearchPage;
